import React, { Fragment, useRef } from 'react'

import { useSelector, shallowEqual } from 'react-redux'
import { useLocation, Redirect } from 'react-router-dom'
import styled from 'styled-components'

import {
    PageBlock,
} from '../'
import {
    ArticleWrap,
    Container,
    Row,
    Meta,
    ContentWrap,
    Hero,
    ArticleWrapColumn,
    Block,
    Title,
    devices,
} from '../Common'


const PageView = () => {
    const { page, notFound } = useSelector(state => state.content, shallowEqual)
    const content = useRef()
    const heroRef = useRef()
    const location = useLocation()

    if (notFound) return <Redirect to='/' />

    return (
        <Fragment>
            <Meta page={page} />
            {page.hero_image ?
                <Hero background={page.hero_image} ref={heroRef}>
                    <HeroContainer>
                        <Title fontSize={60}>{page.title}</Title>
                    </HeroContainer>
                </Hero>
                : ''}
            <PageContainer>
                <Row margintop={50} marginbottom={50}>
                    <ContentWrap ref={content}>
                        <ArticleWrapColumn margintop={40}>
                            <ArticleWrap>
                                {page.blocks && page.blocks.map((pageBlock, i) =>
                                    <Block key={i.toString()} marginbottom={30}>
                                        <PageBlock
                                            pageBlock={pageBlock}
                                            url={page.url}
                                            vision={location.pathname === '/vision/' && i === page.blocks.length - 1}
                                        />
                                    </Block>
                                )}
                            </ArticleWrap>
                        </ArticleWrapColumn>
                    </ContentWrap>
                </Row>
            </PageContainer>
        </Fragment>
    )
}

const PageContainer = styled(Container)`
    min-height: 100vh;
`

const HeroContainer = styled(Container)`
    height: 60%;
    margin-top: auto;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    @media ${devices.small} {
        height: 65%;
        /* margin-bottom: auto; */
    }
`

export default PageView
